angular
	.module 'App.Repository'
	.factory 'VoucherTypeRepository',
	[
		'BaseRepository'
		(BaseRepository) ->
			class VoucherTypeRepository extends BaseRepository
				@resource = '/voucher_types'
				@isRestricted = true

			return new VoucherTypeRepository
	]
